/**
 * Clip Coordinator Service
 * Manages clip state and progress tracking
 * Extracted from main.js to break circular dependencies
 */

import appState from '../core/app-state.js';
import { logEvent } from '../core/event-logger.js';
import * as ProgressService from './progress-service.js';

/**
 * Mark a clip as completed and save progress
 * @param clipId - The clip ID to mark as completed
 */
export function markClipCompleted(clipId: string): void {
  ProgressService.markClipCompleted(clipId);
}

/**
 * Check if a clip has been completed
 * @param clipId - The clip ID to check
 * @returns True if clip is completed
 */
export function isClipCompleted(clipId: string): boolean {
  return ProgressService.isClipCompleted(clipId);
}

/**
 * Update the overall progress UI
 */
export function updateProgressUI(): void {
  const totalClips = appState.clips.length;
  const completedClips = appState.clips.filter(c => isClipCompleted(c.id)).length;
  
  // Log progress update event
  logEvent('progress_update', {
    totalClips,
    completedClips,
    percentage: totalClips > 0 ? Math.round((completedClips / totalClips) * 100) : 0
  });
  
  // Note: Actual UI update happens in the UI layer
  // This function primarily logs the event and can be extended for more complex logic
}

/**
 * Set the current clip by index
 * @param index - The clip index to set as current
 */
export function setCurrentClip(index: number): void {
  if (index >= 0 && index < appState.clips.length) {
    appState.currentClipIdx = index;
    const clip = appState.clips[index];
    if (!clip) return;
    
    appState.activeClipId = clip.id;
    
    // Reset question state for new clip
    appState.currentQuestionIndex = 0;
    
    // Log clip change event
    logEvent('clip_change', {
      clipId: clip.id,
      clipIndex: index,
      clipTitle: clip.title
    });
  }
}
